var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAwsDynamodb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2012 24.7878H14.5026L19.4224 22.3276L19.5043 22.2119V2.57449L19.4224 2.45815L14.5026 0H14.1975L14.2012 24.7878Z",
    fill: "#5294CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79873 24.7878H7.49311L2.57748 22.3276L2.47773 22.156L2.42712 2.6745L2.57748 2.45815L7.49311 0H7.80251L7.79873 24.7878Z",
    fill: "#1F5B98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50177 0H14.4978V24.7878H7.50177V0Z",
    fill: "#2D72B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9978 11.8371L21.8315 11.8003L19.4577 11.5789L19.4225 11.5965L14.4983 11.3995H7.50183L2.57751 11.5965V7.84144L2.57235 7.84419L2.57751 7.8332L7.50183 6.69219H14.4983L19.4225 7.8332L21.2328 8.79541V8.17679L21.9978 8.0931L21.9186 7.93862L19.4963 6.20657L19.4225 6.23054L14.4983 4.7047H7.50183L2.57751 6.23054V2.45825L0.00231934 5.47514V8.10994L0.0222527 8.09551L0.767349 8.17679V8.80812L0.00231934 9.21753V11.8392L0.0222527 11.8371L0.767349 11.8481V12.9485L0.124497 12.9581L0.00231934 12.9464V15.5691L0.767349 15.9805V16.6191L0.0343674 16.7001L0.00231934 16.676V19.3104L2.57751 22.3277V18.5558L7.50183 20.0816H14.4983L19.437 18.5513L19.5027 18.5801L21.8931 16.8735L21.9978 16.7035L21.2328 16.6191V15.9933L21.1325 15.9533L19.4963 16.8352L19.437 16.959L14.4983 18.0933V18.0947H7.50183V18.0933L2.57751 16.9541V13.1854L7.50183 13.3816V13.3864H14.4983L19.4225 13.1854L19.5346 13.2369L21.8355 13.0388L21.9978 12.9595L21.2328 12.9485V11.8481L21.9978 11.8371Z",
    fill: "#1A476F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4224 18.5558V22.3277L21.9978 19.3104V16.6932L19.4373 18.5513L19.4224 18.5558ZM19.4224 16.9624L19.4373 16.959L21.9978 15.5818V12.9485L19.4224 13.1854V16.9624ZM19.4373 7.83663L19.4224 7.8332V11.5965L21.9978 11.8371V9.20507L19.4373 7.83663ZM19.4373 6.24532L21.9978 8.0931V5.47583L19.4224 2.45825V6.23054L19.4373 6.2357V6.24532Z",
    fill: "#2D72B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 24.8307,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsDynamodb);
export default __webpack_public_path__ + "static/media/aws-dynamodb.31da56fdfcbf80f46a87e1baf156914a.svg";
export { ForwardRef as ReactComponent };